module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#toc5"
    }
  }, [_vm._v("Sources Frequently Cited")])]), _vm._v(" "), _c('p', {
    staticClass: "BI"
  }, [_vm._v("Karl Barth, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Church Dogmatics, ")]), _vm._v("13 vols., various translators (Edinburgh: T&T Clark, 1936-1969).")]), _vm._v(" "), _c('p', {
    staticClass: "BI"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Book of Confessions, ")]), _vm._v("Presbyterian Church (U.S.A.) (Louisville: Office of the General Assembly, 1999).")]), _vm._v(" "), _c('p', {
    staticClass: "BI"
  }, [_vm._v("John Calvin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Institutes of the Christian Religion, ")]), _vm._v("2 vols., ed. John T. McNeill (Philadelphia: Westminster Press, 1960).")]), _vm._v(" "), _c('p', {
    staticClass: "BI"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Luther’s Works, ")]), _vm._v("55 vols., gen. eds. Jaroslav Pelikan and Helmut T. Lehman (St. Louis: Concordia; Philadelphia: Fortress, 1955-1986).")]), _vm._v(" "), _c('p', {
    staticClass: "BI"
  }, [_vm._v("Paul Tillich, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Systematic Theology, ")]), _vm._v("3 vols. (Chicago: University of Chicago Press, 1951-1963).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-751671a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Migliore_Faith_Seeking_Understanding_text-5.vue
// module id = 78
// module chunks = 0